import React from 'react'

import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material'

interface AlertBaseProps {
  status: 'error' | 'success' | 'warning'
  title: string
  count: number
  countDescription?: string
  loading?: boolean
  onClick?: () => void
}

export const AlertBase: React.FC<AlertBaseProps> = ({
  status,
  title,
  count,
  countDescription,
  loading,
  onClick
}) => {
  const statusPalette = {
    error: {
      color: 'lightcoral',
      backgroundColor: 'rgba(255, 189, 189, 0.1)'
    },
    success: {
      color: 'rgb(153, 255, 133)',
      backgroundColor: 'rgba(153, 255, 133, 0.1)'
    },
    warning: {
      color: 'rgb(252, 177, 14)',
      backgroundColor: 'rgba(250, 234, 144, 0.1)'
    }
  } as const
  const statusStyle = statusPalette[status]

  return (
    <Card
      elevation={0}
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        border: '1px solid lightgray',
        p: '5px',
        '&:hover': {
          backgroundColor: '#f5f5f5'
        }
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'row',
          p: 0,
          '&:last-child': {
            pb: 0
          }
        }}
      >
        <Box
          sx={{
            color: statusStyle.color,
            backgroundColor: statusStyle.backgroundColor,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            borderRadius: '5px',
            p: '5px',
            textAlign: 'center'
          }}
        >
          <Typography
            variant='caption'
            style={{
              width: '100%'
            }}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {!loading && (
            <Typography variant='body2' component='h6'>
              {count} {countDescription}
            </Typography>
          )}
          {loading && <CircularProgress size={'14px'} />}
        </Box>
      </CardContent>
    </Card>
  )
}
